import FormPasswordForgotten from './FormPasswordForgotten'

export {
  FormPasswordForgotten
}


// WEBPACK FOOTER //
// ./src/components/FormPasswordForgotten/index.js